import { Component, OnInit } from '@angular/core';
import { JumpPageService } from 'src/app/_share/service/jump-page.service';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.less']
})
export class DesignComponent implements OnInit {

  constructor(
    private _jumpPage: JumpPageService,
  ) { }

  public designTitle = 'product.design.designTitle'; // 标题
  public designDesc = 'product.design.designDesc'; //描述
  public designBtn = 'product.design.designBtn'; 
  public designImgSrc = './assets/img/design/design-background.png'; //背景图
  public designLink = 'https://app.oatos.com/os/#/welcome/sign-up'; //链接地址

  public caseContent: Array<any> = [
    {
      imgUrl: './assets/img/design/design-case-img1.png'
    },
    {
      imgUrl: './assets/img/design/design-case-img2.png'
    },
    {
      imgUrl: './assets/img/design/design-case-img3.png'
    }
  ]

  public featureTitle = 'product.design.featureTitle';
  public featureDesc = 'product.design.featureDesc';

  public customizeTitle = 'product.design.customizeTitle';
  public customizeContent: Array<any> = [
    {
      imgUrl: './assets/img/design/design-customize-img1.svg',
      title: 'product.design.customizeContent-title1',
      desc: 'product.design.customizeContent-desc1'
    },
    {
      imgUrl: './assets/img/design/design-customize-img2.svg',
      title: 'product.design.customizeContent-title2',
      desc: 'product.design.customizeContent-desc2'
    },
    {
      imgUrl: './assets/img/design/design-customize-img3.svg',
      title: 'product.design.customizeContent-title3',
      desc: 'product.design.customizeContent-desc3'
    },
    {
      imgUrl: './assets/img/design/design-customize-img4.svg',
      title: 'product.design.customizeContent-title4',
      desc: 'product.design.customizeContent-desc4'
    }
  ]

  ngOnInit(): void {
    this._jumpPage.goTop();
  }

}
